import { type AiBuilderTurnRequest } from '../utils/types';

export const isAiBuilderTurnBusy = ({
  isGenerating,
  turnInProgress,
}: {
  isGenerating: boolean;
  turnInProgress: boolean;
}) => isGenerating || turnInProgress;

export const createAiBuilderClientRequestId = () => {
  // 이미 존재 가드 + 폴백이 있어 웹뷰에서도 throw 하지 않는다. quiz-app 은
  // @zep/utils 표면을 최소로 유지(배럴 drag 회피)하므로 로컬 구현을 유지한다.
  // eslint-disable-next-line zep/no-restricted-syntax -- guarded fallback; quiz-app keeps minimal @zep/utils surface
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    // eslint-disable-next-line zep/no-restricted-syntax -- guarded fallback; quiz-app keeps minimal @zep/utils surface
    return globalThis.crypto.randomUUID();
  }

  return `ai-builder-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const createAiBuilderDraftInstanceId = () =>
  `draft-${createAiBuilderClientRequestId()}`;

export const createMessageTurnRequest = ({
  requestId,
  clientRequestId,
  clientCopy,
  message,
  context,
  analyticsIntent,
}: {
  requestId: number;
  clientRequestId: string;
  clientCopy: AiBuilderTurnRequest['clientCopy'];
  message: string;
  context: AiBuilderTurnRequest['context'];
  analyticsIntent?: AiBuilderTurnRequest['analyticsIntent'];
}): AiBuilderTurnRequest => ({
  requestId,
  clientRequestId,
  clientCopy,
  intent: {
    type: 'message',
    message,
  },
  context,
  ...(analyticsIntent ? { analyticsIntent } : {}),
});

export const createUndoTurnRequest = ({
  requestId,
  clientRequestId,
  clientCopy,
  context,
}: {
  requestId: number;
  clientRequestId: string;
  clientCopy: AiBuilderTurnRequest['clientCopy'];
  context: AiBuilderTurnRequest['context'];
}): AiBuilderTurnRequest => ({
  requestId,
  clientRequestId,
  clientCopy,
  intent: {
    type: 'undo',
  },
  context,
});

export const createConfirmTurnRequest = ({
  requestId,
  clientRequestId,
  clientCopy,
  token,
  decision,
  context,
}: {
  requestId: number;
  clientRequestId: string;
  clientCopy: AiBuilderTurnRequest['clientCopy'];
  token: string;
  decision: 'approve' | 'cancel';
  context: AiBuilderTurnRequest['context'];
}): AiBuilderTurnRequest => ({
  requestId,
  clientRequestId,
  clientCopy,
  intent: {
    type: 'confirm',
    token,
    decision,
  },
  context,
});
